export enum eThemeMode {
    light = "light",
    dark = "dark"
}